export enum CheckoutEventAction {
  PROFILE_CREATED = 'profile-created',
  PROFILE_UPDATED = 'profile-updated',
  PROFILE_SELECTED = 'profile-selected',
}

export const raiseCheckoutEvent = <T>(
  action: CheckoutEventAction,
  payload: T
) => {
  const event = new CustomEvent<{action: CheckoutEventAction; payload: T}>(
    'dm-checkout-event',
    {detail: {action, payload}}
  );
  window.dispatchEvent(event);
};
